module.exports = __webpack_public_path__ + "img/Engineers.49fd4b38.svg";